module.exports = __webpack_public_path__ + "img/825-05e4cc.png";